import React from 'react'
import { IconPropsType } from '../types'

const SortIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      width='16'
      height='16'
      className={className}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_15723_26860)'>
        <path
          d='M2 12H6V10.6667H2V12ZM2 4V5.33333H14V4H2ZM2 8.66667H10V7.33333H2V8.66667Z'
          fill='#323232'
        />
      </g>
      <defs>
        <clipPath id='clip0_15723_26860'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SortIcon
